import React, { useState } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import api from "@/api/client";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { MessageSquare, Send } from "lucide-react";
import { toast } from "sonner";

export default function CommentsPanel({ entityType, entityId }) {
  const qc = useQueryClient();
  const [body, setBody] = useState("");
  const { data: comments = [] } = useQuery({
    queryKey: ["comments", entityType, entityId],
    queryFn: () => api.get(`/${entityType}s/${entityId}/comments`).then((r) => r.data),
    refetchInterval: 8000,
  });
  const add = useMutation({
    mutationFn: () => api.post(`/${entityType}s/${entityId}/comments`, { entity_type: entityType, entity_id: entityId, body, visibility: "internal" }),
    onSuccess: () => { setBody(""); qc.invalidateQueries({ queryKey: ["comments", entityType, entityId] }); toast.success("Commentaire ajouté"); },
  });
  return (
    <div>
      <div className="text-[11px] uppercase tracking-wider text-slate-500 font-semibold mb-2 flex items-center gap-1.5">
        <MessageSquare size={12} /> Commentaires ({comments.length})
      </div>
      <div className="space-y-2 max-h-64 overflow-y-auto mb-3">
        {comments.map((c) => (
          <div key={c.id} data-testid={`comment-${c.id}`} className="rounded-md bg-slate-50 p-2.5 text-xs">
            <div className="flex justify-between text-[10px] text-slate-500 mb-1">
              <span className="font-semibold text-slate-700">{c.created_by_name || "Utilisateur"}</span>
              <span>{new Date(c.created_at).toLocaleString("fr-FR")}</span>
            </div>
            <div className="text-slate-800">{c.body}</div>
          </div>
        ))}
        {comments.length === 0 && <div className="text-xs text-slate-400 text-center py-3">Aucun commentaire</div>}
      </div>
      <div className="flex gap-2">
        <Textarea data-testid="comment-input" value={body} onChange={(e) => setBody(e.target.value)} placeholder="Ajouter un commentaire..." rows={2} className="text-sm" />
        <Button data-testid="comment-send" size="sm" disabled={!body.trim() || add.isPending} onClick={() => add.mutate()} className="text-white shrink-0 self-end" style={{ background: "#023E73" }}>
          <Send size={13} />
        </Button>
      </div>
    </div>
  );
}
